export const GET_LOCATIONS_COLLECTION = "[LOCATIONS] Collection Get";
export const GET_LOCATIONS_COLLECTION_SUCCESS = "[LOCATIONS] Collection Get Success";
export const GET_LOCATIONS_COLLECTION_FAIL = "[LOCATIONS] Collection Get Fail";

export const GET_ITALY_CITIES= "[CHEKIN] Italy Cities Get";
export const GET_ITALY_CITIES_SUCCESS = "[CHEKIN] Italy Cities Get Success";
export const GET_ITALY_CITIES_FAIL = "[CHEKIN] Italy Cities Get Fail";